
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRemoteControllerService } from 'core/api';
import { IControl, SSFormGroup } from 'core/dynamic-form';
import { LoaderService, SnackbarService } from 'core/services';
import { BehaviorSubject, Subject, distinctUntilChanged, map, startWith, take, takeUntil } from 'rxjs';
import { designerPaths } from '../../../designer.paths';

import { DsgDeepTranslationKey } from '../../../pipes/translate.pipe';

@Component({
  selector: 'ss-user-set-password',
  templateUrl: './user-set-password.component.html',
  styleUrls: ['./user-set-password.component.scss'],
  host: {
    class: 'padding-standard flex-column flex--align-center'
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSetPasswordComponent {

  private readonly _destroy = new Subject<void>()

  readonly validatePasswordMatch = (_: any, formGroup: SSFormGroup) =>
    formGroup.valueChanges.pipe(
      map(({ password, passwordConfirm }) => password === passwordConfirm),
    ).pipe(take(1))

  readonly controls: IControl[] = [
    // { dataField: 'prevPassword', type: 'password', label: 'user.prev-password', validationRules: [{ type: 'required' }] } as IControl<'password'>,
    {
      dataField: 'password',
      type: 'password',
      label: 'ss-set-password.password',
      validationRules: [
        { type: 'required' },
      ]
    } as IControl<'password'>,
    {
      dataField: 'passwordConfirm', type: 'password', label: 'ss-set-password.confirm-password',
      validationRules: [
        { type: 'required' },
        { type: 'async', message: 'ss-set-password.passwords-dont-match', key: 'passwords-dont-match', validationCallback: this.validatePasswordMatch }

      ],

    } as IControl<'password'>,
  ]

  readonly userIdSubject = new BehaviorSubject<string>(undefined);
  get userId() {
    return this.userIdSubject.value;
  }
  constructor(
    private readonly _userRemoteControllerService: UserRemoteControllerService,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _router: Router,
    private readonly _loaderService: LoaderService<DsgDeepTranslationKey>,
    private readonly _snackbarService: SnackbarService
  ) {


    this._activatedRoute.params.pipe(
      takeUntil(this._destroy),
      startWith(this._activatedRoute.snapshot.params),
      map((params) => params.userId),
      distinctUntilChanged()
    )
      .subscribe((userId) => {
        this.userIdSubject.next(userId)
      });

  }



  setPassword(formData: any) {

    if (!formData?.password) {
      return;
    }

    const id = this._loaderService.show({ text: 'ss-set-password.pending' })
    this._userRemoteControllerService.setPassword(this.userId, formData.password)
      .pipe(
        this._loaderService.disposeLoader(id),
        this._snackbarService.handleAsync({ errorMessage: 'ss-set-password.error', successMessage: 'ss-set-password.success' }),
        take(1)
      )
      .subscribe(() => {

        this._router.navigate([designerPaths.auth])
      })
  }



  ngOnDestroy() {
    this._destroy.next()
    this._destroy.complete()
  }
}
